module.exports = __webpack_public_path__ + "static/media/hand-right-front.13f1c03e.png";